export function getUpsellParams(ctaType: string, ctaSource: string) {
  return `type=${encodeURIComponent(ctaType)}&source=${encodeURIComponent(
    ctaSource,
  )}`;
}
